import { useState, useEffect } from "react";
import { Search as SearchIcon } from "lucide-react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MovieCard from "../components/MovieCard";

export default function Search() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ movies: [], series: [], channels: [] });

  useEffect(() => {
    if (!q) {
      setRes({ movies: [], series: [], channels: [] });
      return;
    }
    const t = setTimeout(() => {
      api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setRes(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const total = res.movies.length + res.series.length + res.channels.length;

  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid="search-page">
      <Navbar />
      <div className="pt-32 px-4 sm:px-12 max-w-[1600px] mx-auto pb-20">
        <div className="relative mb-8">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-[#888]" size={20} />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search movies, shows, channels, actors..."
            className="w-full pl-12 pr-4 py-4 bg-[#1a1a1a] border border-white/10 rounded-xl text-white text-lg focus:border-[#E50914] focus:outline-none"
            data-testid="search-input"
          />
        </div>

        {!q && <div className="text-[#777] text-center py-12">Start typing to search the library...</div>}
        {q && total === 0 && <div className="text-[#777] text-center py-12">No results for "{q}".</div>}

        {res.movies.length > 0 && (
          <section className="mb-10">
            <h2 className="text-xl font-bold mb-4" style={{ fontFamily: "Outfit" }}>Movies</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
              {res.movies.map((m) => <MovieCard key={m.id} item={m} type="movie" />)}
            </div>
          </section>
        )}
        {res.series.length > 0 && (
          <section className="mb-10">
            <h2 className="text-xl font-bold mb-4" style={{ fontFamily: "Outfit" }}>TV Shows</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
              {res.series.map((s) => <MovieCard key={s.id} item={s} type="series" />)}
            </div>
          </section>
        )}
        {res.channels.length > 0 && (
          <section className="mb-10">
            <h2 className="text-xl font-bold mb-4" style={{ fontFamily: "Outfit" }}>Live Channels</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
              {res.channels.map((c) => <MovieCard key={c.id} item={c} type="channel" />)}
            </div>
          </section>
        )}
      </div>
      <Footer />
    </div>
  );
}
